export const lockerKeys = {
    all: ['locker'] as const,
    zones: (centerId: string) => [...lockerKeys.all, 'zones', centerId] as const,
    status: (centerId: string, zoneId: string) => [...lockerKeys.all, 'status', centerId, zoneId] as const,
    history: (centerId: string, queryParams: any) => [...lockerKeys.all, 'history', centerId, queryParams] as const,
    candidates: (centerId: string, queryParams: any) => [...lockerKeys.all, 'candidates', centerId, queryParams] as const,
    slot: (centerId: string, zoneId: string, lockerNumber: number | string) =>
        [...lockerKeys.all, 'slot', centerId, zoneId, String(lockerNumber)] as const,
};
